import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    periodFormatter,
    dateValueGetter,
    periodValueGetter,
    dateFilterParams,
    periodFilterParams,
    dateComparator,
    periodComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberComparatorMax3, numberFilterParams, numberFilterParamsWithThreeDigits, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processCode"),
            field: "Código de proceso",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processDescription"),
            field: "Descripción",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processType"),
            field: "Tipo de proceso",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processSubtype"),
            field: "Tipo de subproceso",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processDateFrom"),
            field: "Fecha desde",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processDateTo"),
            field: "Fecha hasta",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: "Período",
            filter: "agTextColumnFilter",
            comparator: periodComparator,
            filterParams: periodFilterParams(),
            valueFormatter: periodFormatter,
            valueGetter: periodValueGetter,
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processPaymentDate"),
            field: "Fecha de pago",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("timeCalendar"),
            field: "calendarString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processStatus"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processDateLast"),
            field: "Fecha último proceso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("processTimeLast"),
            field: "Hora último proceso",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            field: "Colaboradores procesados",
            headerName: getLocalizedString("employeesProcessesTitle"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.currentProcesses],
        config: {
            headerName: getLocalizedString("publishedProcess"),
            field: "Proceso publicado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processCode"),
            field: "Código de proceso",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processDescription"),
            field: "Descripción",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processType"),
            field: "Tipo de proceso",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            field: "Proceso por defecto",
            headerName: getLocalizedString("defaultProcess"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processSubtype"),
            field: "Tipo de subproceso",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processDateFrom"),
            field: "Fecha desde",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processDateTo"),
            field: "Fecha hasta",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: "Período",
            filter: "agTextColumnFilter",
            comparator: periodComparator,
            filterParams: periodFilterParams(),
            valueFormatter: periodFormatter,
            valueGetter: periodValueGetter,
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processPaymentDate"),
            field: "Fecha de pago",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("timeCalendar"),
            field: "calendarString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processStatus"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processDateLast"),
            field: "Fecha último proceso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("processTimeLast"),
            field: "Hora último proceso",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            field: "Colaboradores procesados",
            headerName: getLocalizedString("employeesProcessesTitle"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['currentProcessesAutomatic'],
        config: {
            headerName: getLocalizedString("publishedProcess"),
            field: "Proceso publicado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "Estado",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("internalNumber"),
            field: "Número interno",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config:
        {
            headerName: getLocalizedString("functionaryTypePlant"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("contractEndDate"),
            field: "Fecha de egreso",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "Obra o Faena",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("paymentLocation"),
            field: "Lugar de pago",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("category"),
            field: "Categoría",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: "Sindicato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.currentProcessesEmployees],
        config: {
            headerName: getLocalizedString("businessUnit"),
            field: "Unidad de negocio",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Cuenta contable',
            headerName: getLocalizedString("accountCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. de la Cuenta contable',
            headerName: getLocalizedString("accountingAccountDescription"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'Código de concepto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. Centro de costo',
            headerName: getLocalizedString("costCenterDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. del Proyecto',
            headerName: getLocalizedString("projectDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. Centro de costo 2',
            headerName: getLocalizedString("costCenterDescription2"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. Centro de costo 3',
            headerName: getLocalizedString("costCenterDesc3"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. Centro de costo 4',
            headerName: getLocalizedString("costCenterDesc4"),
            filter: "agTextColumnFilter",
        }
    },

    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Desc. Centro de costo 5',
            headerName: getLocalizedString("costCenterDesc5"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Información detallada',
            headerName: getLocalizedString("detailedInformation"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Valores para cabecera',
            headerName: getLocalizedString("headerValues"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByConcept'],
        config: {
            field: 'Valores para detalle',
            headerName: getLocalizedString("valuesForDetail"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Cuenta contable',
            headerName: getLocalizedString("accountCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. de la Cuenta contable',
            headerName: getLocalizedString("accountingAccountDescription"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: 'Proyecto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. del Proyecto',
            headerName: getLocalizedString("projectDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'Código de concepto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: 'Centro de costo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. Centro de costo',
            headerName: getLocalizedString("costCenterDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Centro de costo 2',
            headerName: getLocalizedString("costCenter2"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. Centro de costo 2',
            headerName: getLocalizedString("costCenterDescription2"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Centro de costo 3',
            headerName: getLocalizedString("costCenter3"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. Centro de costo 3',
            headerName: getLocalizedString("costCenterDesc3"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Centro de costo 4',
            headerName: getLocalizedString("costCenter4"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. Centro de costo 4',
            headerName: getLocalizedString("costCenterDesc4"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Centro de costo 5',
            headerName: getLocalizedString("costCenter5"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Desc. Centro de costo 5',
            headerName: getLocalizedString("costCenterDesc5"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Información detallada',
            headerName: getLocalizedString("detailedInformation"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Valores para cabecera',
            headerName: getLocalizedString("headerValues"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByProject'],
        config: {
            field: 'Valores para detalle',
            headerName: getLocalizedString("valuesForDetail"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Cuenta contable',
            headerName: getLocalizedString("accountCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. de la Cuenta contable',
            headerName: getLocalizedString("accountingAccountDescription"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: 'Centro de costo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. Centro de costo',
            headerName: getLocalizedString("costCenterDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'Código de concepto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Centro de costo 2',
            headerName: getLocalizedString("costCenter2"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. Centro de costo 2',
            headerName: getLocalizedString("costCenterDescription2"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Centro de costo 3',
            headerName: getLocalizedString("costCenter3"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. Centro de costo 3',
            headerName: getLocalizedString("costCenterDesc3"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Centro de costo 4',
            headerName: getLocalizedString("costCenter4"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. Centro de costo 4',
            headerName: getLocalizedString("costCenterDesc4"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Centro de costo 5',
            headerName: getLocalizedString("costCenter5"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. Centro de costo 5',
            headerName: getLocalizedString("costCenterDesc5"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: 'Proyecto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Desc. del Proyecto',
            headerName: getLocalizedString("projectDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Información detallada',
            headerName: getLocalizedString("detailedInformation"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Valores para cabecera',
            headerName: getLocalizedString("headerValues"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalyticsByCenter'],
        config: {
            field: 'Valores para detalle',
            headerName: getLocalizedString("valuesForDetail"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Cuenta contable',
            headerName: getLocalizedString("accountCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. de la Cuenta contable',
            headerName: getLocalizedString("accountingAccountDescription"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessReferencia1"),
            field: 'Referencia 1',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessReferencia2"),
            field: 'Referencia 2',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: 'Centro de costo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. Centro de costo',
            headerName: getLocalizedString("costCenterDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Centro de costo 2',
            headerName: getLocalizedString("costCenter2"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. Centro de costo 2',
            headerName: getLocalizedString("costCenterDescription2"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Centro de costo 3',
            headerName: getLocalizedString("costCenter3"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. Centro de costo 3',
            headerName: getLocalizedString("costCenterDesc3"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Centro de costo 4',
            headerName: getLocalizedString("costCenter4"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. Centro de costo 4',
            headerName: getLocalizedString("costCenterDesc4"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Centro de costo 5',
            headerName: getLocalizedString("costCenter5"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. Centro de costo 5',
            headerName: getLocalizedString("costCenterDesc5"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: 'Proyecto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Desc. del Proyecto',
            headerName: getLocalizedString("projectDesc"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Información detallada',
            headerName: getLocalizedString("detailedInformation"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Valores para cabecera',
            headerName: getLocalizedString("headerValues"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            field: 'Valores para detalle',
            headerName: getLocalizedString("valuesForDetail"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'Código de concepto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesAnalytics'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Código de proceso',
            headerName: getLocalizedString("processCode"),
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Descripción del proceso',
            headerName: getLocalizedString("processDescriptionLong"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Cuenta contable',
            headerName: getLocalizedString("accountCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessReferencia1"),
            field: 'Referencia 1',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessReferencia2"),
            field: 'Referencia 2',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: 'Centro de costo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Centro de costo 2',
            headerName: getLocalizedString("costCenter2"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Centro de costo 3',
            headerName: getLocalizedString("costCenter3"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Centro de costo 4',
            headerName: getLocalizedString("costCenter4"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Centro de costo 5',
            headerName: getLocalizedString("costCenter5"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: 'Proyecto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Información detallada',
            headerName: getLocalizedString("detailedInformation"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Valores para cabecera',
            headerName: getLocalizedString("headerValues"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            field: 'Valores para detalle',
            headerName: getLocalizedString("valuesForDetail"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: 'Código de concepto',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesToExport'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            headerName: getLocalizedString("debit"),
            field: 'Débito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            headerName: getLocalizedString("credit"),
            field: 'Crédito',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesCollaborator'],
        config: {
            field: 'Diferencia',
            headerName: getLocalizedString("difference"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['accountingEntriesMissingAccounts'],
        config: {
            headerName: getLocalizedString("accountingEntry"),
            field: 'Asiento',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesMissingAccounts'],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesMissingAccounts'],
        config: {
            headerName: "ID",
            field: 'ID',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesMissingAccounts'],
        config: {
            headerName: getLocalizedString("conceptFamily"),
            field: 'Familia',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['accountingEntriesMissingAccounts'],
        config: {
            headerName: getLocalizedString("clasification"),
            field: 'Clasificación',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["accountingEntriesMissingAccounts"],
        config: {
            headerName: getLocalizedString("imputationType"),
            field: "Tipo de imputación",
            filter: "agSetColumnFilter",
        }
    },
]